import React from "react";
import { AuxButton, AuxValuePair } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { InsQueryStatedElement } from "../base/insQueryStatedElement";
import { InsChartSettings } from "../chart/base/insChartSettings";
import { isEmpty } from "common/object-helper";
import { InsWidget, InsWidgetTitle } from "components/widgets/base";
import "./insValuePairDatapointWidget.scss";
import { useWidgetComponentProps } from "components/widgets/hooks/use-current-widget";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { InsWidgetIcons } from "../icons/insWidgetIcons";
const datapointField = (field, index) => {
    if (field.type === "link") {
        if (!field.value) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: "linkWrapper", key: `${field.title}-${index}` },
            field.image && React.createElement(InsWidgetIcons, { src: field.image }),
            React.createElement(AuxButton, { label: field.title, icon: field.icon, type: AuxButtonTypeEnum.TERTIARY, onClick: () => window.open(field.value, "_blank"), isIconRight: true })));
    }
    return (React.createElement(AuxValuePair, { label: field.title, value: field.value, size: field.size, isPipeLess: field.isPipeless ?? true, isBold: true, removeSpacing: true }));
};
export const InsValuePairDatapointWidget = (props) => {
    const { sectionId, widgetId } = props, { userSettings, noCard } = useWidgetComponentProps(sectionId, widgetId);
    const [[response], queryState] = useGetDatapointsWidgetData(props);
    const data = response?.data ?? [];
    const rows = data[0]?.fields.map((_, index) => data.map((column) => column.fields[index]));
    const numberOfColumns = data.length ?? 1;
    const content = React.createElement(InsQueryStatedElement, { queryState: queryState, widgetFactoryProps: props, hasData: Boolean(data.length > 0) },
        React.createElement("div", { className: "valuePairWidgetGrid", style: { gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)` } }, rows?.map((row) => {
            const rowKey = row.map((field) => field?.title).join("-");
            const rowColumns = row.filter((field) => field?.title).length || 1;
            return (React.createElement(React.Fragment, { key: rowKey }, row.map((field, i) => field?.title && React.createElement("div", { key: field.title, style: {
                    gridColumn: `span ${Math.max(1, Math.floor(numberOfColumns / rowColumns))}`
                } }, datapointField(field, i)))));
        })));
    return React.createElement(InsWidget, { sectionId: sectionId, widgetId: widgetId, showMaximize: false, content: content, footer: React.createElement(React.Fragment, null), settingsContent: isEmpty(userSettings) ? undefined : React.createElement(InsChartSettings, { ...props }), title: React.createElement(InsWidgetTitle, { ...props }), noMarginOnContent: noCard, noCard: noCard });
};
